import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { noop, Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import {
  InquiryResponse,
  ShiftTimeResponse,
  BaseCoreState,
  baseInquirySelectors,
  ShiftPlanCalendarDateInterface,
  BaseModalService,
  BaseBusinessKeyPipe,
  EditInquiryFormInterface,
  ShiftType,
  TimeAndShiftsFormInterface,
  BaseShiftIcons,
} from 'base';

@Component({
  selector: 'base-customer-shift-plan-calendar',
  templateUrl: './base-customer-shift-plan-calendar.component.html',
})
export class BaseCustomerShiftPlanCalendarComponent implements OnInit, OnDestroy {
  @ViewChild('editTimeShifts', { static: true }) editTimeShifts: ElementRef;
  @Input() editInquiryForm: FormGroup<EditInquiryFormInterface>;

  inquiry: Partial<InquiryResponse> = {};
  calendarDatesList: ShiftPlanCalendarDateInterface[] = [];
  baseShiftIconsEnum = BaseShiftIcons;
  timeShiftsModalRef: NgbModalRef;
  activeShiftType: ShiftType;

  private destroy$ = new Subject<boolean>();

  constructor(
    private store: Store<BaseCoreState>,
    private modalService: BaseModalService,
    private businessKeyPipe: BaseBusinessKeyPipe
  ) {}

  get timeShiftsForm() {
    return this.editInquiryForm.controls.timeShiftsForm as FormArray<FormGroup<TimeAndShiftsFormInterface>>;
  }

  ngOnInit() {
    this.store
      .select(baseInquirySelectors.getShiftPlanList)
      .pipe(
        takeUntil(this.destroy$),
        map((data) => data.list as ShiftPlanCalendarDateInterface[])
      )
      .subscribe((data: ShiftPlanCalendarDateInterface[]) => {
        this.calendarDatesList = data;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  openEditShiftTimesModal(shiftType: ShiftType) {
    this.activeShiftType = shiftType;
    this.timeShiftsModalRef = this.modalService.open(
      {
        headText: this.businessKeyPipe.transform('action.editShiftTimes'),
        bodyTemplate: this.editTimeShifts,
        hideFooter: true,
        width: 600,
      },
      {
        backdrop: 'static',
      }
    );

    this.timeShiftsModalRef.result.then(() => noop, noop);
  }

  trackByShiftTime(_: number, item: ShiftTimeResponse) {
    return item.type;
  }
}
